var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52867 12.4679L10.5531 19.5585C10.875 19.8429 11.2903 20 11.7205 20C12.1507 20 12.566 19.8429 12.888 19.5585L20.9117 12.4679C28.9545 5.37835 18.9392 -5.03505 11.72 3.30233C5.4488 -5.55795 -4.77603 5.44905 2.52867 12.4679Z",
    fill: "#F97A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e2e40bdc05ade2e7841044bdb5c8f456.svg";
export { ForwardRef as ReactComponent };